import { useEffect, useState } from "react";
import Nav from "../components/Nav";
import LocationHeader from "../components/main/LocationHeader";
import Footer from "../components/Footer";
import { Helmet } from "react-helmet";
import ScrollNavbar from "../components/ScrollNavbar";
import NumberIncrement from "../components/NumberIncrement";
import ExploreGroomingService from "../components/ExploreGroomingService";
import LocationComponent from "../components/main/LocationComponent";
import MeetExpertsComponent from "../components/main/MeetExpertsComponent";
import HowFt from "../components/HowFt";
import LocationFaqComponent from "../components/main/LocationFaqComponent";
import NavTop from "../components/NavTop";
import OurLocation from "../components/OurLocation";
import LocationContentNoida from "../components/main/LocationContentNoida";
import PopupOffer from "../components/PopupOffer";
import GroomingFormComponent from "../components/form/GroomingFormComponent";
import LocationGroomingPackageComponent from "../components/LocationGroomingPackageComponent";

const NoidaPage = () => {
  const [openForm, setOpenForm] = useState(false);
  
    const [offerPopup, setOfferPopup] = useState(false);
  
      const [petGroom, setPetGroom] = useState("Dog")
  

    useEffect( () => {
  
      const timer = setTimeout( () => {
        setOfferPopup(true)
      }, 15000)
  
      return () => clearInterval(timer)
  
    },[])
    
    
  
  

  const headerData = {
    heading: "Professional At-Home Pet Grooming in Noida ",
    text: "Same Day Booking - Smart Choice for Noida Pet Parents.",
  };

  const faqData = {
    heading: "",
    data: [
      {
        question: "Which areas in Noida do you cover?",
        text: ["✅ We serve all sectors in Noida & Greater Noida, including:"],
        points: [
          "Central Noida: Sectors 12-52, 62, 128",
          "Greater Noida West: Gaur City, Panchsheel Greens",
          "New Noida: Sectors 70-79, 137-143",
          "(Call to confirm exact society coverage!)",
        ],
      },
      {
        question: "How quickly can a groomer arrive at my home?",
        text: [
          "⏳ Same-day slots available! Most bookings are fulfilled within 1-2 hours in prime sectors (18, 50, 76).",
        ],
        points: [],
      },
      
      {
        question: "Why is home grooming costlier than Noida salons?",
        text: ["Our pricing reflects:"],
        points: [
          "Doorstep convenience (no travel stress)",
          "1-on-1 attention (no crowded salons)",
          "Premium products (pH-balanced for Indian breeds)",
        ],
      },
      {
        question: "Do you groom aggressive or anxious pets?",
        text: ["Yes! Our certified groomers are trained in:"],
        points: [
          "Low-stress handling techniques",
          "Muzzle-friendly grooming (if needed)",
          "Slow introductions for first-time pets",
        ],
      },
      {
        question: "Can you handle Persian cats’ matted fur?",
        text: ["Absolutely! We use:"],
        points: [
          "Detangling sprays (pain-free removal)",
          "Lion cuts for severely matted coats",
          "Sanitary trims for hygiene",
        ],
      },
      {
        question: "What if my pet gets injured during grooming?",
        text: ["All groomers:"],
        points: [
          "Carry first-aid kits",
          "Are trained in CPR for pets",
          "Follow sterilization protocols for tools",
        ],
      },
      {
        question: "Do I need to provide anything?",
        text: [],
        points: [
          "A power outlet (for clippers/dryers)",
          "Your pet’s favorite treats (for positive reinforcement)",
          "Vaccination records (for puppy/senior pets)",
        ],
      },
      {
        question: "Can I reschedule my appointment?",
        text: [
          "Yes! No fees if rescheduled 6+ hours before. ⚠️ Late cancellations (<2 hours) incur 50% charges.",
        ],
        points: [],
      },
      {
        question: "Do you offer cat grooming in Gaur City?",
        text: [
          "✅ Yes! We serve all societies in Gaur City and Noida Extension with parking access.",
        ],
        points: [],
      },
      {
        question: "Can you handle emergency mat removal?",
        text: [
          "✅ Yes! Same-day detangling for matted fur, especially for Persian cats",
        ],
        points: [],
      },
      {
        question: "Do you groom aggressive or anxious pets?",
        text: ["Yes! Our certified groomers use:"],
        points: [
          "Low-stress handling for nervous dogs",
          "Muzzle-friendly techniques",
          "Slow introductions for first-timers",
        ],
      }
    ],
  };

  const locationData = {
    data: [
      "Sector 1–37",
      "Sector 39–44",
      "Sector 45–50",
      "Sector 51–56",
      "Sector 57–64",
      "Sector 65–71",
      "Sector 72–79",
      "Sector 80–89",
      "Sector 90–99",
      "Sector 100–107",
      "Sector 108–113",
      "Sector 118–122",
      "Sector 123–137",
      "Sector 143–150",
      "Sector 151–168",
      "Sector 168–168A",
      "Film City",
      "Noida City Centre",
      "Botanical Garden Area",
      "Sector 18 Market",
      "Sector 62 IT Hub",
      "Sector 15 Metro Area",
      "Sector 137–Expressway",
      "Sector 76–Metro Zone",
      "Noida-Greater Noida Expressway",
      "Jewar Airport Zone",
      "Yamuna Expressway Area",
      "Bhangel",
      "Nithari",
      "Salarpur",
      "Harola",
      "Barola",
      "Chhalera",
    ],
  };

  const schema = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": "FluffyTouch Pet Grooming",
  "@id": "https://fluffytouch.in/pet-grooming-at-home/noida",
  "url": "https://fluffytouch.in/pet-grooming-at-home/noida",
  "telephone": "+919658189189",
  "image": "https://fluffytouch.in/assets/logo.png",
  "priceRange": "₹999–₹2399",
  "address": {
    "@type": "PostalAddress",
    "addressLocality": "Noida",
    "addressRegion": "UP",
    "postalCode": "201301",
    "addressCountry": "IN"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": 28.5355,
    "longitude": 77.3910
  },
  "openingHours": "Mo-Su 09:00-21:00",
  "areaServed": {
    "@type": "Place",
    "name": [
      "Sector 15", "Sector 18", "Sector 50", "Sector 62", "Sector 76",
      "Sector 128", "Gaur City", "Noida Extension", "Sector 137",
      "Greater Noida", "Bhangel", "Barola", "Chhalera", "Sector 100",
      "Sector 143", "Jewar Airport Zone", "Yamuna Expressway Area"
    ]
  },
  "sameAs": [
    "https://www.facebook.com/fluffytouch.in",
    "https://www.instagram.com/fluffytouch.in"
  ],
  "serviceType": "Dog Grooming, Cat Grooming, Pet Spa at Home",
  "offers": {
    "@type": "Offer",
    "url": "https://fluffytouch.in/pet-grooming-at-home/noida",
    "priceCurrency": "INR",
    "price": "999",
    "availability": "https://schema.org/InStock",
    "validFrom": "2025-05-10",
"validThrough": "2025-09-08",

    "eligibleRegion": {
      "@type": "Place",
      "name": "Noida"
    }
  }
}

const schema2 = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "Do you provide pet grooming in Gaur City and Noida Extension?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, we serve all societies in Gaur City, Panchsheel Greens, and across Noida Extension."
      }
    },
    {
      "@type": "Question",
      "name": "Is same-day grooming available in Noida?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, same-day slots are available in key sectors like 18, 50, 62, 76, and 137."
      }
    },
    {
      "@type": "Question",
      "name": "Do you offer emergency grooming for matted fur?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Absolutely. Call us for emergency detangling and hygiene trims, especially for Persian cats."
      }
    },
    {
      "@type": "Question",
      "name": "Do you handle aggressive or anxious pets?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, our certified groomers use low-stress and muzzle-friendly techniques to groom anxious dogs or cats."
      }
    },
    {
      "@type": "Question",
      "name": "What payment methods are accepted?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "We accept UPI (PhonePe, GPay), cash, and cards (via POS machine)."
      }
    }
  ]
}




  return (
    <div>
      <div className="noida-page">
        <Helmet>
          <title>
            At-Home Pet Grooming Noida | Same-Day Service | 50,000+ Pets
          </title>
          <meta
            name="description"
            content="
          🚀 Certified groomers at your doorstep in 60 minutes! Serving all sectors of Noida. Pain-free grooming for dogs and cats. Book now and get ₹30% OFF!
        "
          />
           <script type="application/ld+json">{JSON.stringify(schema)}</script>
           <script type="application/ld+json">{JSON.stringify(schema2 )}</script>

          
        </Helmet>

        {openForm ? <GroomingFormComponent setDynamicForm={setOpenForm} /> : ""}
        {offerPopup ? <PopupOffer open={setOfferPopup} /> : ""}

        <ScrollNavbar />

        <NavTop />
        <Nav />

        <LocationHeader
          heading={headerData.heading}
          text={headerData.text}
          form={setOpenForm}
          setPetGroom={setPetGroom}
        />

        <NumberIncrement />

        <ExploreGroomingService />

        <LocationGroomingPackageComponent petGroom={petGroom} setPetGroom={setPetGroom} />

        <LocationComponent location="Noida" data={locationData.data} />
        <MeetExpertsComponent form={setOfferPopup} />

        <HowFt />

        <LocationContentNoida />

      <OurLocation />


        <LocationFaqComponent data={faqData.data} />

        <Footer />
      </div>
    </div>
  );
};

export default NoidaPage;
